import $ from 'jQuery';
import './machine_app_progressbar.css';

/**
* @param {number} pInitialStep - initial step. Must be [0, pTotalSteps]
* @param {number} pTotalSteps - if not initially sent as argument, must be sent using updateProgress method
* @param {boolean} pIsPercentage - if the user wants results in percentage instead of fraction
*/
export function progressBar({ pInitialStep, pTotalSteps, pIsPercentage }){
  const lWrapper = $('<div>').addClass('machineapp_progress_bar_wrapper');
  const lProgressContainer = $('<div>').addClass('machineapp_progress_bar_container').appendTo(lWrapper);
  const lEmptyBar = $('<div>').addClass('machineapp_progress_bar_general machineapp_progress_bar_empty_bar').appendTo(lProgressContainer);
  const lProgressValue = $('<h5>').addClass('machineapp_progress_bar_value_container').appendTo(lProgressContainer);
  const lFilledBar = $('<div>').addClass('machineapp_progress_bar_general machineapp_progress_bar_filled_bar').appendTo(lEmptyBar);

  let lTotalSteps = pTotalSteps;
  let lCurrentStep = pInitialStep;

  function update() {
    console.assert(lCurrentStep >= 0, `The current step must be >= 0. CurrentStep=${lCurrentStep}, TotalSteps=${lTotalSteps}`);
    console.assert(lTotalSteps !== undefined, 'Total steps MUST be defined for an update to happen.');
    console.assert(lCurrentStep <= lTotalSteps, `The current step must be <= the total steps. CurrentStep=${lCurrentStep}, TotalSteps=${lTotalSteps}`);

    const lPercentageAmountValue = Math.floor(100 * lCurrentStep / lTotalSteps);
    lFilledBar.css({'width':`${lPercentageAmountValue}%`});
    if(!pIsPercentage){
      lProgressValue.text(`Completed ${Math.min(lCurrentStep, lTotalSteps)}/${lTotalSteps}`);
    }
    else {
      lProgressValue.text(`${lPercentageAmountValue}%`);
    }
  }

  const lControls = {};
  lControls.updateProgress = function(pCurrentStep, pNewTotalSteps = undefined) {
    lCurrentStep = pCurrentStep;
    if (pNewTotalSteps) lTotalSteps = pNewTotalSteps;
    update();
  };

  lControls.resetProgress = function() {
    lCurrentStep = pInitialStep;
    if (pTotalSteps !== undefined) {
      update();
    }
  };

  if(pTotalSteps !== undefined) {
    update();
  }

  return {
    widget: lWrapper,
    controls: lControls
  };
}